import { z } from 'zod';
export const JsonPrimitiveValueSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
]);
export const FlexibleRecordSchema = z.record(z.string(), JsonPrimitiveValueSchema);
export const IdSchema = z
    .string()
    .regex(/^[a-z]+_[a-zA-Z0-9_]+$/, 'Invalid ID format - must match pattern: prefix_alphanumeric');
export const TimestampSchema = z.string().datetime();
export const DateSchema = z.string().date();
export const EmailSchema = z.string().email();
export const UriSchema = z.string().url();
export const PaginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(20).optional(),
    sort: z.string().optional(),
    order: z.enum(['asc', 'desc']).default('desc').optional(),
});
export const PaginationMetaSchema = z.object({
    page: z.number().int().min(1),
    limit: z.number().int().min(1),
    total: z.number().int().min(0),
    total_pages: z.number().int().min(0),
    has_next: z.boolean(),
    has_prev: z.boolean(),
});
export function createPaginatedResponseSchema(dataSchema) {
    return z.object({
        data: z.array(dataSchema),
        pagination: PaginationMetaSchema,
    });
}
export const DateRangeSchema = z.object({
    start_date: z.string().datetime().optional(),
    end_date: z.string().datetime().optional(),
});
export const MetadataSchema = z.record(z.string(), z.unknown()).default({});
export const AuditFieldsSchema = z.object({
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    created_by: z.string().optional(),
    updated_by: z.string().optional(),
});
export const TenantContextSchema = z.object({
    tenant_id: z.string(),
    environment_id: z.string(),
});
export const IdParamsSchema = z.object({
    id: z.string(),
});
export const BulkDeleteSchema = z.object({
    ids: z.array(z.string()).min(1).max(100),
});
export const BulkOperationResultSchema = z.object({
    success: z.number().int().min(0),
    failed: z.number().int().min(0),
    total: z.number().int().min(0),
    errors: z
        .array(z.object({
        id: z.string(),
        error: z.string(),
    }))
        .optional(),
});
export const ValidationErrorResponseSchema = z.object({
    error: z.string(),
});
export const ErrorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
export const SuccessResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
});
//# sourceMappingURL=types.js.map